import script from "./infoBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./infoBlock.vue?vue&type=script&lang=ts&setup=true"

import "./infoBlock.vue?vue&type=style&index=0&id=99faa7d2&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99faa7d2"]])

export default __exports__